import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  playerData,
  players,
  seasons,
  seasonNames,
  seasonNamesShort,
} from "./playerData.js";

const options = players;

function bfs_shortest_path(graph, start, goal) {
  // keep track of explored nodes
  var explored = [];
  // keep track of all the paths to be checked
  var queue = [[start]];

  // return path if start is goal
  if (start === goal) {
    return [start];
  }

  // keeps looping until all possible paths have been checked
  while (queue.length > 0) {
    // pop the first path from the queue
    var path = queue.shift();
    // get the last node from the path
    var node = path[path.length - 1];
    if (!explored.includes(node)) {
      let neighbours = graph[node].slice(0);
      // go through all neighbour nodes, construct a new path and
      // push it into the queue

      for (var i = 0; i < neighbours.length; i++) {
        var neighbour = neighbours[i];

        var newPath = path.slice(0);
        newPath.push(neighbour);
        queue.push(newPath);
        // return path if neighbour is goal
        if (neighbour === goal) {
          return newPath;
        }
      }
      // mark node as explored
      explored.push(node);
    }
  }
  // in case there's no path between the 2 nodes
  return [-1];
}

function findLink(graph, start, goal) {
  if (start && goal) {
    if (start === goal) {
      return "That's the same person!";
    }
    let startI = players.indexOf(start);
    let goalI = players.indexOf(goal);
    if (startI > -1 && goalI > -1) {
      return mapToPlayers(bfs_shortest_path(graph, startI, goalI));
    }
  }
}

function mapToPlayers(playerList) {
  if (playerList.length === 1) {
    return "There is no link between these players (Rob and Sandra in S39 don't count).";
  }
  var l = [];
  for (var fff = 0; fff < playerList.length; fff++) {
    l.push(players[playerList[fff]]);
  }
  var s = l[0] + " played with ";

  for (var p = 1; p < l.length - 1; p++) {
    s += l[p] + " in ";
    s += findCommonSeason(playerList[p], playerList[p - 1]);

    s += ", who played with ";
  }
  s +=
    l[l.length - 1] +
    " in " +
    findCommonSeason(
      playerList[playerList.length - 2],
      playerList[playerList.length - 1]
    ) +
    ".";
  return s;
}

function findCommonSeason(p1s, p2s) {
  console.log(p1s);
  console.log(p2s);
  console.log(seasons[p1s]);
  console.log(seasons[p2s]);
  var a = seasons[p1s]; //seasons the first was in
  var b = seasons[p2s]; //seasons the second was in
  var commonSeasons = [];
  for (var i = 0; i < a.length; i++) {
    for (var j = 0; j < b.length; j++) {
      if (a[i] === b[j]) {
        commonSeasons.push(a[i]);
      }
    }
  }
  var commonSeasonsString = "";
  if (commonSeasons.length === 1) {
    commonSeasonsString = seasonNamesShort[commonSeasons[0]];
  } else if (commonSeasons.length === 2) {
    commonSeasonsString =
      seasonNamesShort[commonSeasons[0]] +
      " and " +
      seasonNamesShort[commonSeasons[1]];
  } else {
    for (var s = 0; s < commonSeasons.length - 1; s++) {
      commonSeasonsString += seasonNamesShort[commonSeasons[s]] + ", ";
    }
    commonSeasonsString +=
      " and " + seasonNamesShort[commonSeasons[commonSeasons.length - 1]];
  }

  return commonSeasonsString;
}

export default function ControllableStates() {
  const [value1, setValue1] = React.useState(null);
  const [inputValue1, setInputValue1] = React.useState("");
  const [value2, setValue2] = React.useState(null);
  const [inputValue2, setInputValue2] = React.useState("");

  return (
    <>
      <div>
        <br />
        <Autocomplete
          value={value1}
          onChange={(event, newValue) => {
            setValue1(newValue);
          }}
          inputValue={inputValue1}
          onInputChange={(event, newInputValue) => {
            setInputValue1(newInputValue);
          }}
          id="player1"
          options={options}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Player 1" variant="outlined" />
          )}
        />
        <br></br>
        <Autocomplete
          value={value2}
          onChange={(event, newValue) => {
            setValue2(newValue);
          }}
          inputValue2={inputValue2}
          onInputChange={(event, newInputValue) => {
            setInputValue2(newInputValue);
          }}
          id="player2"
          options={options}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Player 2" variant="outlined" />
          )}
        />
        <br></br>
      </div>
      <h2>{findLink(playerData, value1, value2)}</h2>
    </>
  );
}
